import { useRouteError } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";


const ErrorPage = () => {
    const error = useRouteError();
    console.warn(error);

    return (
        <div className="App">
            <Header />
            <main>
                <h1>Something Went Wrong...</h1>
                <p>Sorry, an Unexpected error has occured.</p>
                <p>
                    <i>{error.status} | {error.statusText}</i>
                </p>
                <p>
                    <i>{error.data}</i>
                </p>
            </main>
            <Footer />
        </div>
    )

}

export default ErrorPage;